/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { List, ListItem } from '@mui/material';
import RequiredDocumentItem from '../RequiredDocumentItem/RequiredDocumentItem';
import { DisplayedDocument } from '../../../providers/types';

export type RequiredDocumentsListProps = {
    documents: Array<DisplayedDocument>;
    onUpload: (dossierId: number, documentId: number, file: File, fichierId?: number) => void;
    onDeletion: (fichierId: number) => void;
    onDownload: (fichierId: number) => void;
    onMove: (label: string, fichierId: number) => void;
    onShow: (label: string, fichierId: number, documentId: number) => void;
    onClick?: (documentId: number, fichierId: number) => void;
};

const RequiredDocumentsList: React.FunctionComponent<RequiredDocumentsListProps> = function (
    props,
) {
    const {
        documents,
        onUpload: handleUpload,
        onDeletion: handleDeletion,
        onDownload: handleDownload,
        onMove: handleMove,
        onShow: handleShow,
        onClick: handleClick = (documentId: number, fichierId: number) => {},
    } = props;

    const getItemKey = (document: DisplayedDocument) => {
        if (document.fichierId) {
            return `${document.id}-${document.fichierId}`;
        }

        return String(document.id);
    };

    const listSx = {
        padding: '0',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px 0',
    };

    const listItemSx = {
        padding: '0',
        display: 'block',
    };

    const items = documents.map((document) => (
        <ListItem
            key={getItemKey(document)}
            sx={listItemSx}
            data-testid="required-document-list-item"
        >
            <RequiredDocumentItem
                {...document}
                onChange={
                    document.fichierId
                        ? (files: FileList) =>
                              handleUpload(
                                  document.dossierId,
                                  document.id as number,
                                  files[0],
                                  document.fichierId as number,
                              )
                        : (files: FileList) =>
                              handleUpload(
                                  document.dossierId,
                                  document.id as number,
                                  files[0],
                                  undefined,
                              )
                }
                onDeletion={
                    document.fichierId
                        ? () => handleDeletion(document.fichierId as number)
                        : () => {}
                }
                onDownload={
                    document.fichierId
                        ? () => handleDownload(document.fichierId as number)
                        : () => {}
                }
                onShow={
                    document.fichierId
                        ? () =>
                              handleShow(document.label, document.fichierId as number, document.id)
                        : () => {}
                }
                onMove={
                    document.fichierId
                        ? () => handleMove(document.label, document.fichierId as number)
                        : () => {}
                }
                onClick={() => handleClick(document.id as number, document.fichierId as number)}
            />
        </ListItem>
    ));

    return <List sx={listSx}>{items}</List>;
};

export default RequiredDocumentsList;
